import { GameSpinsRemainingProperties } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/properties/GameSpinsRemainingProperties";
/**
 * SpinsRemainingLandscapeProperties.ts
 */
export class SpinsRemainingLandscapeProperties extends GameSpinsRemainingProperties {
    constructor() {
        super();
        this.position.set(1550, 541);
    }
}
//# sourceMappingURL=SpinsRemainingLandscapeProperties.js.map